import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Progress,
  Badge,
  Table,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from "reactstrap";
import { connect } from "react-redux";
import Header from "components/Headers/Header";

const Performance = (props) => {
    const [ongoing, setOngoing] = useState(true);
    const [activeTab, setActiveTab] = useState("overview");

    const toggleTab = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

  // Placeholder data - replace with real data later
  const performanceData = {
    overallProgress: 75,
    datProgress: 68,
    coursesCompleted: 12,
    totalCourses: 18,
    studyHours: 145,
    targetHours: 200,
    averageScore: 85,
    recentScores: [78, 82, 85, 88, 91, 87, 89],
    strengths: ["Biology", "General Chemistry", "Reading Comprehension"],
    weaknesses: ["Organic Chemistry", "Quantitative Reasoning"],
    upcomingGoals: [
      { task: "Complete Organic Chemistry Module 3", deadline: "Dec 5, 2025" },
      { task: "DAT Practice Test #4", deadline: "Dec 10, 2025" },
      { task: "Review Biology Flashcards", deadline: "Dec 3, 2025" }
    ]
  };

  return (
    <>
        <Header />
        <Container className="mt--7" fluid>
            <Row>
                <Col>
                    <Card className="p-4">
                        <h1>Performance Analytics</h1>
                        <p>Welcome to the Performance Analytics!</p>
                        Coming soon...
                    </Card>
                </Col>
            </Row>
        </Container>
    </>
  );
};

const mapStateToProps = (state) => ({
  userDetails: state.loginAuth.userDetails,
});

export default connect(mapStateToProps)(Performance);